<template slot="default" slot-scope="{ hide }">
  <div>
    <b-button
      class="col-md-2 mt-1 mb-1"
      style="margin-left: 1000px"
      variant="success"
      @click="uploadfilemodelfunction()"
      download
      >Upload Image File</b-button
    >

    <b-card no-body>
      <b-tabs pills card>
        <b-tab
          title="All Images"
          active
          v-if="this.user_type == 'Brand_Designer'"
          @click="getGraphicsDesignListing('all', 'Shape', 1)"
        >
          <b-tabs pills card>
            <b-tab
              title="Shape"
              active
              @click="getGraphicsDesignListing('all', 'Shape', 1)"
            >
              <b-card-text>
                <!-- all design for designer starts -->
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}
                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <v-lazy-image
                            v-bind:src="designs.thumbnail_url"
                            :class="imgIsLoaded ? 'show' : ''"
                            loading="lazy"
                            @load="imgLoadedMethod"
                            class="img_class"
                          />

                          <!-- <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          /> -->
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab
              title="Pattern"
              @click="getGraphicsDesignListing('all', 'Pattern', 1)"
            >
              <b-card-text>
                <!-- all design for designer starts -->
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}
                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <v-lazy-image
                            v-bind:src="designs.thumbnail_url"
                            :class="imgIsLoaded ? 'show' : ''"
                            loading="lazy"
                            @load="imgLoadedMethod"
                            class="img_class"
                          />

                          <!-- <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          /> -->
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- ~~~~~ all design for designer ends~~~~~~~ -->

        <!-- ~~~~~~~~~~~~~ uploaded by designer starts~~~~~~~~~~~~~~ -->
        <b-tab
          title="Uploaded by me"
          v-if="this.user_type == 'Brand_Designer'"
          @click="getGraphicsDesignListing('me', 'Shape', 1)"
        >
          <b-tabs pills card>
            <b-tab
              title="Shape"
              active
              @click="getGraphicsDesignListing('me', 'Shape', 1)"
            >
              <b-card-text>
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback1"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}

                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          />
                          <!-- <div style="text-align: center;">

                            <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                            @load="imgLoadedMethod"

                            class="img_class"/>

                            

                            </div> -->
                        </b-col>
                        <b-col>
                          <b
                            v-if="
                              designs.original_image_by != null &&
                              designs.original_image_by != ''
                            "
                            ><a
                              @click="seeOriginalImage(designs.original_image)"
                              class="pointer"
                              >Original Image:
                              {{ designs.original_image_by }}</a
                            ></b
                          >
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab
              title="Pattern"
              @click="getGraphicsDesignListing('me', 'Pattern', 1)"
            >
              <b-card-text>
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback1"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}

                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          />
                          <!-- <div style="text-align: center;">

                            <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                            @load="imgLoadedMethod"

                            class="img_class"/>

                            

                            </div> -->
                        </b-col>
                        <b-col>
                          <b
                            v-if="
                              designs.original_image_by != null &&
                              designs.original_image_by != ''
                            "
                            ><a
                              @click="seeOriginalImage(designs.original_image)"
                              class="pointer"
                              >Original Image:
                              {{ designs.original_image_by }}</a
                            ></b
                          >
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-tab>
        <!-- ~~~~~~~~~~~~~~ uploaded by designer ends  ~~~~~~~~~~~~~~~~~~~-->

        <!-- ~~~~~~~~~~~~~~~~~~~~~~~~EDITed design starts ~~~~~~~~~~~~~~~~~~ -->

        <b-tab
          title="Edited Design"
          v-if="this.user_type == 'Brand_Designer'"
          @click="getGraphicsDesignListing('edited', 'Shape', 1)"
        >
          <b-tabs pills card>
            <b-tab
              title="Shape"
              active
              @click="getGraphicsDesignListing('edited', 'Shape', 1)"
            >
              <b-card-text>
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback2"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}

                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          />
                          <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                        </b-col>
                        <b-col>
                          <b
                            v-if="
                              designs.original_image_by != null &&
                              designs.original_image_by != ''
                            "
                            ><a
                              @click="seeOriginalImage(designs.original_image)"
                              class="pointer"
                              >Original Image:</a
                            >
                            {{ designs.original_image_by }}</b
                          >
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col md="3">
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="border:1px solid #F2F2F2; padding-top:10px; padding-bottom:10px;"
                        >
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                            <label for="name" class=" mt-2"
                              ><b>
                                Image Name
                              </b></label
                            >
                            <a class="pull-right mt-2">
                              <i class="fa fa-download"></i
                            ></a>
                          </b-col>
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                          </b-col>
                          <b-col md="12">
                            <img
                              src="/img/navy_smiley.jpg"
                              style="height:200px; width:200px;"
                            />
                          </b-col>
                          <b-col>
                            <a @click="seeOriginalImage()" class="pointer"
                              ><b>Original Image</b></a
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    -->
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab
              title="Pattern"
              active
              @click="getGraphicsDesignListing('edited', 'Pattern', 1)"
            >
              <b-card-text>
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback2"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}

                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          />
                          <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                        </b-col>
                        <b-col>
                          <b
                            v-if="
                              designs.original_image_by != null &&
                              designs.original_image_by != ''
                            "
                            ><a
                              @click="seeOriginalImage(designs.original_image)"
                              class="pointer"
                              >Original Image:</a
                            >
                            {{ designs.original_image_by }}</b
                          >
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col md="3">
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="border:1px solid #F2F2F2; padding-top:10px; padding-bottom:10px;"
                        >
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                            <label for="name" class=" mt-2"
                              ><b>
                                Image Name
                              </b></label
                            >
                            <a class="pull-right mt-2">
                              <i class="fa fa-download"></i
                            ></a>
                          </b-col>
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                          </b-col>
                          <b-col md="12">
                            <img
                              src="/img/navy_smiley.jpg"
                              style="height:200px; width:200px;"
                            />
                          </b-col>
                          <b-col>
                            <a @click="seeOriginalImage()" class="pointer"
                              ><b>Original Image</b></a
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    -->
                </b-row>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- ~~~~~~~~~~~~~~~~~~~~~~~ EDITED design ends ~~~~~~~~~~~~~~~~~~~~~~~ -->

        <!-- ~~~~~~~~~~~~~ Tab for graphic designer starts~~~~~~~~~~~~~~ -->
        <b-tab
          title="Gallery"
          v-if="this.user_type == 'Graphics_Designer'"
          @click="getGraphicsDesignListing('me', 'Shape', 1)"
        >
          <b-tabs pills card>
            <b-tab
              title="Shape"
              active
              @click="getGraphicsDesignListing('me', 'Shape', 1)"
            >
              <b-card-text>
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="1"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}
                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          />
                          <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab
              title="Pattern"
              @click="getGraphicsDesignListing('me', 'Pattern', 1)"
            >
              <b-card-text>
                <paginate
                  v-if="this.design_details.length > 0"
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="1"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginate>
                {{ errorMsg }}
                <b-row>
                  <b-col
                    md="3"
                    v-for="designs in design_details"
                    :key="designs"
                  >
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="
                          border: 1px solid #f2f2f2;
                          padding-top: 10px;
                          padding-bottom: 10px;
                        "
                      >
                        <b-col
                          md="12"
                          style="background-color: #e4e5e6; margin-bottom: 10px"
                        >
                          <b-row>
                            <b-col md="8">
                              <label for="name" class="mt-2"
                                ><b>{{ designs.artwork_title }}</b></label
                              >
                            </b-col>
                            <b-col>
                              <a
                                class="pull-right mt-2"
                                :href="designs.image_url"
                                download
                              >
                                <i class="fa fa-download"></i
                              ></a>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="12">
                          <img
                            v-bind:src="designs.thumbnail_url"
                            class="img_class"
                            style=""
                          />
                          <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-tab>
        <!-- ~~~~~~~~~~~~~~Tab for graphic designer  ends ~~~~~~~~~~~~~~~~~~~-->
      </b-tabs>
    </b-card>

    <!-- Add File Model -->
    <b-modal
      title="Upload Image"
      v-model="uploadfilemodel"
      @ok="uploadfilemodel = false"
    >
      <b-form
        name="fileform"
        @submit.prevent="validateForm('form-1')"
        data-vv-scope="form-1"
      >
        <b-col class="filedesign">
          <b-col sm="12">
            <b-form-group>
              <label>Image Name</label>
              <b-input
                v-model="file_name"
                placeholder="Enter File name"
                required
              >
              </b-input>
            </b-form-group>
            <b-form-group>
              <label for="name">Upload File</label>
              <b-form-file
                v-model="file"
                :state="Boolean(file)"
                accept="image/png, image/jpeg"
                placeholder="Upload Image"
                @change="selectFile($event)"
                required
                :class="{
                  input: true,
                  'text-danger': errors.has('form-1.file'),
                }"
              ></b-form-file>

              <b-input-group>
                <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('file')"></i>
                </span>
                <span
                  style="width: 240px"
                  v-show="errors.has('form-1.file')"
                  class="help text-danger"
                  >{{ errors.first("form-1.file") }}</span
                >
              </b-input-group>

              <!-- Code For Progress Bar -->
              <div
                class="progress"
                id="progress_bar"
                style="
                  display: none;
                  margin-top: 7px;
                  margin-bottom: 7px;
                  width: 100%;
                  height: 30px;
                  font-size: 18px;
                  font-weight: bold;
                "
              >
                <div
                  class="progress-bar progress-bar-info progress-bar-striped"
                  role="progressbar"
                  :aria-valuenow="progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{
                    height: '30px',
                    text: '20px',
                    align: 'center',
                    width: progress + '%',
                  }"
                >
                  {{ progress }}%
                </div>
              </div>
              <!-- Code For Progress Bar Ends -->
            </b-form-group>
          </b-col>
          <div slot="footer" id="upload_btn">
            <b-button
              type="button"
              @click="cancelmodal()"
              style="float: right"
              variant="danger"
              class="px-4"
              >Cancel</b-button
            >
            <b-button
              type="submit"
              style="float: right"
              variant="primary"
              class="px-4 mr-1"
              >Upload File</b-button
            >
          </div>
        </b-col>
      </b-form>
    </b-modal>
    <!--  End Add File Model -->

    <!-- ~~~~~~~~~ originalImageModal starts -->
    <b-modal
      title="Original Image"
      v-model="originalImageModal"
      @ok="originalImageModal = false"
    >
      <b-col class="filedesign">
        <b-col sm="12">
          <b-form-group>
            <!-- <label class="ml-3"><b>Image Name</b></label> -->
            <b-col md="12">
              <img
                v-bind:src="this.origin_image_name"
                class="mb-3"
                style="height: 200px; width: 200px"
              />
            </b-col>
            <!-- <p class="ml-3"><b>Uploaded By:-</b> ABCD</p>
            <p class="ml-3"><b>Uploaded Date:-</b> 18/04/2023</p> -->
          </b-form-group>
        </b-col>
        <div slot="footer" id="upload_btn">
          <b-button
            type="button"
            @click="cancelmodalimage()"
            style="float: right"
            variant="danger"
            class="px-4"
            >Cancel</b-button
          >
        </div>
      </b-col>
    </b-modal>
    <!-- ~~~~~~~~~~~~ originalImageModalEnds -->
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import VLazyImage from "v-lazy-image/v2";
import auth from "@/utils/auth";
import Vue from "vue";
import Utils from "@/utils";

const axios = require("axios");

export default {
  name: "dashboard",
  components: {
    //  VuePdfEmbed,
    VLazyImage,
  },

  data() {
    return {
      name: "dashboard",
      uploadfilemodel: false,
      user_type: "",
      user_id: "",
      originalImageModal: false,
      file_name: "",
      selectedFiles: "",
      progress: 0,
      design_details: [],
      keyword: "all",
      type: "Shape",
      origin_image_name: "",
      errorMsg: "",
      noofpages: "",
      total_records: [],
      count_arr: [],
      total_design_rows: 0,
      pageNo: 1,
    };
  },

  created: function () {
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    this.user_id = userInfo[0].user_id;
    if (this.user_type == "Brand_Designer") {
      this.keyword = "all";
      this.type = "Shape";
      this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
    } else if (this.user_type == "Graphics_Designer") {
      this.keyword = "me";
      this.type = "Shape";
      this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
    }
  },

  methods: {
    uploadfilemodelfunction: function () {
      this.uploadfilemodel = true;
    },
    cancelmodal: function () {
      this.uploadfilemodel = false;
    },
    seeOriginalImage: function (url) {
      this.origin_image_name = url;
      this.originalImageModal = true;
    },
    cancelmodalimage: function () {
      this.originalImageModal = false;
    },

    validateForm(scope) {
      // alert(scope);
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.uploadDesign();
        }
      });
    },

    selectFile($event) {
      this.selectedFiles = event.target.files[0];
      console.log(
        this.selectedFiles,
        "selectedFilesselectedFilesselectedFiles"
      );
    },

    uploadDesign: function () {
      document.getElementById("progress_bar").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      this.progress = 0;

      let data = new FormData();
      data.append("file", this.selectedFiles);
      data.append("artwork_title", this.file_name);
      data.append("uploaded_by", this.user_id);
      data.append("user_type", this.user_type);
      data.append("file_type", "pattern");

      axios
        .post(`${CONSTANTS.API_URL}/uploadGraphicsDesign`, data, {
          onUploadProgress: function (progressEvent) {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }.bind(this),
        })
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          // JSON responses are automatically parsed.
          this.result = response.data;
          this.quotationlistModel = true;
          if (this.result.returnmsg === "successful") {
            this.$fire({
              text: "Design Uploaded Successfully!",
              type: "success",
              timer: 30000,
            });
            (this.file_name = ""),
              (document.getElementById("progress_bar").style.display = "none");
            this.uploadfilemodel = !this.uploadfilemodel;
            // this.selectedFiles = "",
            if (this.user_type == "Brand_Designer") {
              this.keyword = "all";
              this.type = "Shape";
              this.getGraphicsDesignListing(
                this.keyword,
                this.type,
                this.pageNo
              );
            } else if (this.user_type == "Graphics_Designer") {
              this.keyword = "me";
              this.type = "Shape";
              this.getGraphicsDesignListing(
                this.keyword,
                this.type,
                this.pageNo
              );
            }
          } else {
            this.$fire({
              text: "Something went wrong, Please try again",
              type: "error",
              timer: 30000,
            });
            this.uploadfilemodel = !this.uploadfilemodel;
            if (this.user_type == "Brand_Designer") {
              this.keyword = "all";
              this.type = "Shape";
              this.getGraphicsDesignListing(
                this.keyword,
                this.type,
                this.pageNo
              );
            } else if (this.user_type == "Graphics_Designer") {
              this.keyword = "me";
              this.type = "Shape";
              this.getGraphicsDesignListing(
                this.keyword,
                this.type,
                this.pageNo
              );
            }
            this.errors.push(e);
          }
        });
    },

    clickCallback(pageNo) {
      if (this.user_type == "Brand_Designer") {
        this.keyword = "all";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      } else if (this.user_type == "Graphics_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      }
    },

    clickCallback1(pageNo) {
      if (this.user_type == "Brand_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      } else if (this.user_type == "Graphics_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      }
    },

    clickCallback2(pageNo) {
      if (this.user_type == "Brand_Designer") {
        this.keyword = "edited";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      } else if (this.user_type == "Graphics_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      }
    },

    getGraphicsDesignListing: function (keyword, type, pageno) {
      // alert(type);
      // alert(pageNo)
      const Obj = {
        user_type: this.user_type,
        user_id: this.user_id,
        keyword: keyword,
        type: type,
        limit: "8",
        page_no: pageno,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getGraphicsDesignListing`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "successful") {
            this.design_details = response.data.returnvalue;
            console.log(this.design_details, "this.comment_details");

            this.total_design_rows = response.data.totalCount;
            console.log("HHHHHH", this.total_design_rows);

            this.noofpages = parseInt(this.total_design_rows) / 6;

            this.noofpages = Math.ceil(this.noofpages);
            this.total_records.push(response.data.returnvalue.length);
            var temp = [];
            for (var i = 0; i <= this.total_records; i++) {
              this.count_arr.push(i);
            }
          } else if (response.data.returnmsg === "unsuccessful") {
            this.errorMsg = "No Data";
            this.design_details = [];
          }
        });
    },
  },
};
</script>
<style>
.img_class {
  width: 80%;
  height: 224px !important;
  margin-top: 12px;
  text-align: center;
  padding-bottom: 27px;
  /*border-radius: 50em;*/
}

.v-lazy-image {
  opacity: 0;
  transform: scale3d(0.3, 0.3, 0.3);
  transition: opacity 0.5s, transform 0.5s;
}

.v-lazy-image-loaded {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
</style>
